import { If } from "components";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Pagination, SearchInput } from "ui";

import {
  UnverifiedResellerModal,
  UnverifiedResellersTable
} from "../../components";
import { useUnverifiedResellersList } from "../../hooks";
import { UnverifiedReseller } from "../../resellers.types";

import styles from "./Verification.module.scss";

const Verification = () => {
  const { t } = useTranslation();
  const {
    value: isResellerModalOpen,
    setTrue: openResellerModal,
    setFalse: closeResellerModal
  } = useBoolean(false);

  const [openedReseller, setOpenedReseller] =
    useState<UnverifiedReseller | null>(null);

  const {
    unverifiedResellers,
    searchValue,
    setSearchValue,
    isLoading,
    sorting,
    page,
    setPage,
    totalItems,
    setSorting,
    refetchUnverifiedResellers
  } = useUnverifiedResellersList();

  const onCloseResellerModal = () => {
    closeResellerModal();
    setOpenedReseller(null);
  };

  const onResellerRowClick = (selectedReseller: UnverifiedReseller) => {
    setOpenedReseller(selectedReseller);
    openResellerModal();
  };

  return (
    <ContentLayout counter={totalItems} title={`${t("Verification")}`}>
      <BoxShadowLayout className={styles.pageContent}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={t("Search...")}
        />

        <UnverifiedResellersTable
          resellersList={unverifiedResellers ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          onRowClick={onResellerRowClick}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      <If condition={openedReseller}>
        <UnverifiedResellerModal
          reseller={openedReseller as UnverifiedReseller}
          isOpen={isResellerModalOpen}
          onClose={onCloseResellerModal}
          refetchResellers={refetchUnverifiedResellers}
        />
      </If>
    </ContentLayout>
  );
};

export default Verification;
